import { get, put } from '../utils/networking';

/** How the organisation works with HMS */
export type HmsSettings = {
  /** Norway requires safety representatives. Elsewhere they can be turned off, and the team leader acts alone. */
  usesSafetyReps: boolean;
};

const PATH = '/api/hms/settings';

export const getHmsSettings = () => get<HmsSettings>(PATH);

export const saveHmsSettings = (settings: HmsSettings) => put<void>(PATH, settings);
